var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8737_7030)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.99992,
    cy: 7,
    r: 6.41667,
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.875V7.72487C7 7.26075 7.18437 6.81563 7.51256 6.48744L7.875 6.125C8.35825 5.64175 8.35438 4.85438 7.87113 4.37113V4.37113C7.39214 3.89214 6.6117 3.8883 6.1327 4.3673V4.3673C5.94102 4.55898 5.83333 4.81896 5.83333 5.09004V5.25",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9.91667V9.97501",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8737_7030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundQuestionMark);
export default __webpack_public_path__ + "static/media/round-question-mark.bc73b265c34e73efdae0990b7cd9d217.svg";
export { ForwardRef as ReactComponent };